import React from 'react';
import { Route } from 'react-router';
const renderRoutes = (routes, extraProps = {}) => routes.map((route, i) => (React.createElement(Route, { key: route.key || i, path: route.path, exact: route.exact, strict: route.strict, render: props => route.render
        ? route.render(Object.assign(Object.assign(Object.assign({}, props), extraProps), { route: route }))
        : React.createElement(route.component, Object.assign({}, props, extraProps, { route: route })) })));
export default renderRoutes;
